import Vue from 'vue'
// import requisitionsToPurchase from '@/transformers/catalog/warehouse/requisitionsToPurchase'

/**
 * @author jorge nuñez lópez <>
 *
 * Send requisitions to approve re-entrys 
 * @param Requisition Requisition object
 * @return {object}
 */

export default (requisition) => {
  // const payload = requisitionsToPurchase.send(requisition)
  return Vue.$http.post(`/iwarehouse/approve-re-entry/`, requisition)
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/approveReEntry.js